export default "__VITE_ASSET__Df87rmH1__";